import React from "react";
import "./BonCadeau.css";

const ZENCHEF_SHOP_URL =
  "https://shop.zenchef.com/?active-collection=vouchers&collections=vouchers&shop-id=sh_00d7565d-a56e-47d9-b743-c17644918316&language=fr&primary-color=e8e7df";

const features = [
  { icon: "fa-solid fa-sliders", label: "Montant de votre choix" },
  { icon: "fa-solid fa-globe", label: "En ligne ou sur place" },
  { icon: "fa-solid fa-gift", label: "Idéal pour toutes les occasions" },
];

function BonCadeau() {
  return (
    <main className="cadeau-page" aria-labelledby="cadeau-title">

      {/* ── En-tête ─────────────────────────────────────────── */}
      <header className="cadeau-header">
        <span className="cadeau-eyebrow">Faites plaisir</span>
        <h1 id="cadeau-title">
          Nos <em>bons cadeaux</em>
        </h1>
        <div className="cadeau-header-divider" />
        <p className="lead">
          À la recherche du cadeau parfait ? Nos bons cadeaux, du montant de
          votre choix, sont disponibles sur place ou en ligne !
        </p>
      </header>

      {/* ── Carte cadeau + atouts ─────────────────────────────── */}
      <section className="cadeau-showcase">
        <figure className="cadeau-card">
          <img
            src="images/CarteCadeau.png"
            alt="Bon cadeau Trilogie"
            loading="lazy"
          />
        </figure>

        <ul className="cadeau-features">
          {features.map((f) => (
            <li className="cadeau-feature" key={f.label}>
              <span className="cadeau-feature-icon">
                <i className={f.icon} />
              </span>
              <span>{f.label}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* ── CTA ─────────────────────────────────────────────── */}
      <footer className="cadeau-footer">
        <p className="cadeau-footer-text">
          Offrez un bon cadeau Trilogie et laissez vos proches choisir leur
          moment.
        </p>
        <a
          className="contact-btn"
          href={ZENCHEF_SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Acheter un bon cadeau
          <span className="contact-btn-arrow" />
        </a>
        <p className="cadeau-footer-note">
          Également disponible directement au restaurant.
        </p>
      </footer>

    </main>
  );
}

export default BonCadeau;
